export default __webpack_public_path__ + "static/media/6.7bf77df1.jpg";